enum Version {
  v1 = "v1",
}

class DocumentationEndpoint {
  public swaggerURL(version: Version = Version.v1) {
    const v2path = process.env.VUE_APP_API_URL as string;

    return `${v2path.replace("/api/v2", "")}/${version}.yaml`;
  }
}

export default DocumentationEndpoint;
